import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Overview silently drops parts from the body, so without a permanent marker you can be reading a
// summary and never know it. This pill lives in the header badge row — on screen the moment the
// song renders — and doubles as the exit, since the plugin toggle can be collapsed out of reach.
const OverviewPill = ({ shown, total, onExit }) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className="overview-pill"
      onClick={onExit}
      title={t('view.overviewTitle')}
      aria-label={t('view.overviewLabel', { shown, total })}
    >
      <span className="overview-pill__dot" aria-hidden="true" />
      <span className="overview-pill__label">{t('view.overview')}</span>
      <span className="overview-pill__count">
        {shown}/{total}
      </span>
      <span className="overview-pill__exit" aria-hidden="true">
        ✕
      </span>
    </button>
  );
};

OverviewPill.propTypes = {
  shown: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onExit: PropTypes.func.isRequired,
};

export default OverviewPill;
